import { alphRoot, alphNumMap, isProductionMode } from "./constants"

export function genAlphNum(index) {
  let alph = ""
  index
    .toString()
    .split("")
    .forEach(key => {
      alph = alph + alphNumMap[key]
    })

  return alphRoot.slice(alph.length) + alph
}

export function getFrameUrl(path, index) {
  const urlParts = [
    // "http://localhost:8004",
    `/${path}/`,
    "frame_",
    genAlphNum(index),
    ".",
    "png",
  ]
  return urlParts.join("")
}

export function get3dFrameUrl(path, index, degree) {
  const urlParts = [
    // "http://localhost:8004",
    `/${path}/${index}/`,
    "frame_",
    genAlphNum(degree),
    ".",
    "png",
  ]
  return urlParts.join("")
}

export const initFathomAnalytics = () => {
  if (isProductionMode) {
    // prettier-ignore
    ;(function(f, a, t, h, o, m){a[h]=a[h]||function(){(a[h].q=a[h].q||[]).push(arguments)};o=f.createElement("script"),m=f.getElementsByTagName("script")[0];o.async=1; o.src=t; o.id="fathom-script";m.parentNode.insertBefore(o,m)})(document, window, "https://cdn.usefathom.com/tracker.js", "fathom");

    fathom("set", "siteId", "MZQEEVVX")
    fathom("trackPageview")
  }
}
